<template>
    <div class="dsTable w-full" :class="{loader: disabled}">
        <div class="flex items-center justify-center" v-if="loader">
            <c-loader color="rgba(var(--vs-primary), 1)"></c-loader>
        </div>

        <vs-card class="shadow-none dsTable-card" v-if="panel && !loader">
            <slot name="panel"></slot>
        </vs-card>

        <div class="dsTable__header" v-if="!loader">
            <div class="flex justify-between items-center">
                <div class="flex items-center">
                    <slot name="header"></slot>
                    <div v-if="paginateDropdown">
                        <vs-dropdown v-if="paginate" vs-trigger-click
                                     class="cursor-pointer mr-4 items-per-page-handler">
                            <div
                                class="p-4 border border-solid flex d-theme-border-grey-light rounded-full flex-grow d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                                <span class="mr-2 whitespace-no-wrap">
                                    {{ (pagex - 1) * limit + 1 }} - {{
                                        (pagex - 1) * limit + limit
                                    }} of {{ total ? total : dataList.length }}
                                </span>
                                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                            </div>
                            <vs-dropdown-menu>
                                <vs-dropdown-item v-for="(item, index) of viewItems" :key="index"
                                                  @click="changeLimit(item)">
                                    <span>{{ item }}</span>
                                </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>
                </div>
                <div class="flex items-center">
                    <vs-input
                        v-if="search"
                        icon-pack="feather"
                        icon="icon-search"
                        :placeholder="$t('global.Search')"
                        v-model="searchInput"
                        class="search is-label-placeholder w-full mr-4"
                    />
                    <vs-pagination
                        v-if="paginate"
                        ref="pagination"
                        :class="[{'loader': paginationLoader}, {'disabled-pagination' : !getTotalPages}]"
                        :max="refPaginationPagesLength < 9 ? refPaginationPagesLength : 9"
                        :total="getTotalPages"
                        v-model="pagex"
                    />
                </div>
            </div>
        </div>
        <div class="dsTable__content" v-if="!loader">
            <table ref="table" class="w-full">
                <thead ref="thead">
                <tr :class="{contentCenter}">
                    <th style="width: 20px;" v-if="expand"></th>
                    <th class="dsTable__arrow pl-4" style="width: 20px;" v-if="select && !expand">
                        <input :disabled="disabledSelect" class="dsTable__checkbox" type="checkbox"
                               @change="selectListAllAction" :checked="ids"/>
                    </th>
                    <th v-for="(head, index) of heads" :key="index"
                        v-if="head.display && isPermission(head.can)"
                        :class="{[head.class]: head.class}"
                        :style="{width: head.width}"
                    >
                        <div class="flex items-center head pt-4 pb-4 pl-2 pr-2"
                             :style="{'justify-content': head.headerPosition}"
                             @click="sortItem(head.sortKey)"
                        >
                            <div class="vs-table-text uppercase select-none whitespace-no-wrap"
                                 :class="{'text-center': head.center}">
                                {{ head.translate === 'none' ? head.name : $t(head.name) }}
                            </div>
                            <div
                                v-if="head.sortKey && currentSort.type && currentSort.name === head.sortKey"
                                class="ml-2"
                                :class="{activeExpand: currentSort.type === 'desc'}"
                            >
                                <vs-icon v-if="head.sortKey" icon-pack="feather" icon="icon-chevron-down"></vs-icon>
                            </div>
                        </div>
                    </th>
                </tr>
                </thead>
                <tbody ref="tbody">

                <slot name="tbody" />

                <template v-for="(item, index) of tableData"
                          v-if="tableData.length"
                >
                    <tr :key="index"
                        @click="changeExpand(index)"
                        :class="{'spacertr': spacer, 'spacertr_gr': spacerGrey, contentCenter}"
                    >
                        <td class="td dsTable__arrow" v-if="expand">
                            <div class="chevron-down" :class="{activeExpand: expandx[index]}">
                                <vs-icon icon-pack="feather" icon="icon-chevron-down"></vs-icon>
                            </div>
                        </td>
                        <td class="td pl-4" :class="{'spacertd': spacer}" v-if="select && !expand">
                            <input type="checkbox"
                                   class="dsTable__checkbox"
                                   @change="selectItem(item[selectKey])"
                                   :checked="(selectList || []).includes(item[selectKey])"
                                   :disabled="disabledSelect"
                            />
                        </td>
                        <td class="td"
                            v-for="(head, ind) of heads"
                            :class="{'spacertd': spacer}"
                            :key="ind"
                            :style="{width: head.width}"
                            v-if="head.display && isPermission(head.can) && shouldShowCell(index, head.value)"
                            :rowspan="calculateRowSpan(index, head.value)"
                        >
                            <div class="flex pt-4 pb-4 pl-2 pr-2" :style="{'justify-content': head.headerPosition}">
                                <slot :name="head.value" v-bind="{[head.value]: item}">
                                    <div class="whitespace-no-wrap">{{
                                            item[head.value] !== '' && item[head.value] !== null ? item[head.value] : '-'
                                        }}
                                    </div>
                                </slot>
                            </div>
                        </td>
                    </tr>
                    <tr class="expand" :ref="`expand_${index}`" v-if="expand && expandx[index]">
                        <td class="p-0" :colspan="expand ? heads.length + 1 : heads.length">
                            <slot name="expand" v-bind="{expand: item}"></slot>
                        </td>
                    </tr>
                    <tr v-if="!spacer">
                        <td class="p-2"></td>
                    </tr>
                </template>
                </tbody>
            </table>
        </div>
        <div v-if="!tableData.length && !loader" class="w-full text-center not-data-table vs-table--not-data">
            {{ toDataText ? toDataText : $t('global.No_data') }}
        </div>
        <div class="mt-4" v-if="paginate && !loader">
            <vs-pagination
                :class="[{'loader': paginationLoader}, {'disabled-pagination' : !getTotalPages}]"
                ref="pagination2"
                :max="refPaginationPagesLength < 9 ? refPaginationPagesLength : 9"
                :total="getTotalPages"
                v-model="pagex"
            ></vs-pagination>
        </div>
    </div>
</template>

<script>
import {fixHindusPagination, checkPermission, utils} from '@/utils/mixins'
import ErrorHandler from "@/utils/errorHandler"

export default {
    mixins: [fixHindusPagination, checkPermission, utils],
    props: {
        disabledSelect: {
            type: Boolean,
            default: false
        },
        select: {
            type: Boolean,
            default: false
        },
        selectKey: {
            type: String,
            default: () => 'id'
        },
        panel: {
            type: Boolean,
            default: false
        },
        toDataText: {
            type: String,
        },
        heads: {
            type: Array,
            required: true
        },
        data: {
            type: Array,
            required: true
        },
        expand: {
            type: Boolean,
            default: false
        },
        spacer: {
            type: Boolean,
            default: false
        },
        spacerGrey: {
            type: Boolean,
            default: false
        },
        accordion: {
            type: Boolean,
            default: false
        },
        search: {
            type: Boolean,
            default: false
        },
        searchKeys: {
            type: Array,
            default: () => []
        },
        maxItems: {
            type: Number
        },
        viewItems: {
            type: Array,
            default: () => {
                return [10, 15, 20]
            }
        },
        total: {
            type: Number
        },
        ssr: {
            type: Boolean,
            default: false
        },
        paginate: {
            type: Boolean,
            default: true
        },
        paginateDropdown: {
            type: Boolean,
            default: true
        },
        page: {
            type: Number,
            default: 1
        },
        can: {
            type: String
        },
        searchProps: {
            type: Array,
            default: () => {
                return []
            }
        },
        groupBy: {
            type: Array,
            default: () => {
                return []
            }
        },
        disabled: {
            type: Boolean,
            default: false
        },

        contentCenter: {
            type: Boolean
        },

        loader: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            all: false,
            dataList: [],
            searchDataList: [],
            currentSort: {},
            currentSortActive: null,
            expandx: {},
            pagex: 1,
            limit: 10,
            searchInput: '',
            refPaginationPagesLength: 0,
            paginationLoader: false,
            selectList: [],
            selectListAll: false
        }
    },

    computed: {
        tableDataSort() {
            if (!this.groupBy.length) {
                return this.dataList
            }

            return [...this.dataList].sort((a, b) => {
                for (const key of this.groupBy) {
                    if (a[key] < b[key]) return -1
                    if (a[key] > b[key]) return 1
                }
                return 0
            })
        },

        tableData() {
            if (this.ssr) {
                return this.tableDataSort
            } else {
                const index = (this.pagex - 1) * this.limit
                return this.tableDataSort.slice(index, index + this.limit)
            }
        },

        getTotalPages() {
            return Math.ceil((this.total ? this.total : this.dataList.length) / this.limit)
        },

        ids() {
            let bool = true

            for (const id of this.listIds) {
                if (!this.selectList.includes(id)) {
                    bool = false
                    continue
                }
            }

            return bool
        },

        listIds() {
            return this.dataList.map(item => item[this.selectKey])
        }
    },

    watch: {
        data(value) {
            if (this.ssr) {
                this.paginationLoader = false
            }

            if (!this.ssr) {
                this.dataList = this._searchSort(value)

                this.pagex = this.getTotalPages < this.pagex ? 1 : this.pagex
            } else {
                this.dataList = value

                this.findSelectElements()
            }
        },

        maxItems(num) {
            this.limit = num
        },

        page(page) {
            this.pagex = page
        },

        pagex() {
            if (this.expand) {
                this.closeExpands()
            }

            if (this.ssr) {
                this.$emit('page', this.pagex)
                this.paginationLoader = true
            }
        },

        limit() {
            this.pagex = 1

            if (this.ssr) {
                this.$emit('limit', this.limit)
            }
        },

        searchInput(value) {
            if (!this.ssr) {
                if (this.expand) {
                    this.closeExpands()
                }

                this.dataList = this._searchSort(this.data)

                if (this.dataList.length) {
                    this.pagex = 1
                }
            } else {
                this.$emit('search', value)
            }
        },

        selectList(list) {
            this.selectListAll = list.length === this.dataList.length

            this.$emit('selected', list)
        },
    },

    methods: {
        shouldShowCell(index, key) {
            if (!this.groupBy.includes(key)) {
                return true
            }

            return index === 0 || !this.isSameGroup(index, key)
        },

        calculateRowSpan(index, key) {
            if (!this.groupBy.includes(key)) {
                return 1
            }

            let count = 1

            for (let i = index + 1; i < this.tableDataSort.length; i++) {
                if (!this.isSameGroup(i, key, index)) {
                    break
                }
                count++
            }

            return count
        },

        isSameGroup(currentIndex, key, referenceIndex = currentIndex - 1) {
            const groupKeysBefore = this.groupBy.slice(0, this.groupBy.indexOf(key) + 1)

            return groupKeysBefore.every(groupKey =>
                this.tableDataSort[currentIndex][groupKey] === this.tableDataSort[referenceIndex][groupKey]
            )
        },

        clearSelect() {
            this.selectList = []
        },

        setSelect(arr) {
            this.selectList = arr
        },

        findSelectElements() {
            let count = 0
            const data = this.dataList.map(item => item[this.selectKey])

            this.selectList.map(item => {
                if (data.includes(item)) {
                    count++
                }
            })

            this.selectListAll = count === ~~this.limit
        },

        selectItem(id) {
            if (this.selectList.includes(id)) {
                this.selectList = this.selectList.filter(item => item !== id)
            } else {
                this.selectList.push(id)
            }
        },

        selectListAllAction(event) {
            if (event.target.checked) {
                this.selectList.push(...this.listIds)
            } else {
                for (const id of this.listIds) {
                    this.selectList = this.selectList.filter(item => item !== id)
                }
            }
        },

        _searchSort(data) {
            const list = this.searchInData(data, this.searchInput.toLowerCase())
            return this.currentSort.name ? this.sort(list, this.currentSort) : list
        },

        resultFilter(data) {
            this.dataList = data
        },

        refresh() {
            const axp = {...this.expandx}
            this.closeExpands()
            this.$nextTick(() => {
                this.expandx = axp
            })
        },

        _convertStr(str) {
            return str.split('').map(s => /\W/.test(s) ? "\\" + s : s).join('')
        },

        searchInData(data, str) {
            try {
                if (str) {
                    const keys = [...this.heads.map(head => head.key), ...this.searchKeys]
                    const list = []

                    for (const item of data) {
                        const values = []

                        const func = (element, key) => {
                            if (Array.isArray(element)) {
                                element.map(item => Object.entries(item).map(([valueKey, value]) => {
                                    if (keys.includes(valueKey)) func(value, valueKey)
                                }))
                            } else if (Object.isObject(element)) {
                                Object.entries(item).map(([valueKey, value]) => {
                                    if (keys.includes(valueKey)) func(value, valueKey)
                                })
                            } else if (typeof element === 'string' || typeof element === 'number') {
                                if (keys.includes(key)) values.push(element.toString().toLowerCase())
                            }
                        }

                        for (const [key, value] of Object.entries(item)) {
                            if (typeof value === 'string' || typeof value === 'number') {
                                if (keys.includes(key)) values.push(value.toString().toLowerCase())
                            } else {
                                func(value, key)
                            }
                        }

                        const search = Array.from(new Set(values))
                            .toString()
                            .search(this._convertStr(str).toLowerCase())

                        if (search !== -1) {
                            list.push(item)
                        }
                    }

                    return list
                } else {
                    return data
                }
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        changeLimit(element) {
            this.limit = element
        },

        changeExpand(index) {
            if (this.expand) {
                if (this.accordion && !this.expandx[index])
                    Object.keys(this.expandx).map(key => delete this.expandx[key])
                this.$set(this.expandx, index, !this.expandx[index])
            }
        },

        closeExpands() {
            this.expandx = {}
        },

        sortItem(key) {
            if (key) {
                if (this.expand) {
                    this.closeExpands()
                }

                if (this.currentSortActive !== key) {
                    this.currentSort.type = null
                }

                this.currentSortActive = this.currentSort.name = key

                if (!this.currentSort.type) {
                    this.currentSort.type = 'desc'
                } else if (this.currentSort.type === 'desc') {
                    this.currentSort.type = 'asc'
                } else {
                    this.currentSort.type = null
                }

                if (this.ssr) {
                    this.$emit('sort', this.currentSort)
                } else {
                    this.dataList = this._searchSort(this.data)
                }
            }
        },

        sort(data, action) {
            const _data = JSON.parse(JSON.stringify(data))

            const compare = (a, b) => {
                let ax = a[action.name]
                let bx = b[action.name]

                if (!this.isNumber(a[action.name]) && !this.isNumber(b[action.name])) {
                    ax = ax.toLowerCase()
                    bx = bx.toLowerCase()
                } else {
                    ax = +ax
                    bx = +bx
                }

                if (ax < bx)
                    return action.type === 'desc' ? 1 : -1
                if (ax > bx)
                    return action.type === 'desc' ? -1 : 1

                return 0
            }

            return action.type !== null ? [..._data].sort(compare) : [..._data]
        }
    },

    mounted() {
        if (this.maxItems) {
            this.limit = this.maxItems
        }

        this.dataList = this.data

        this.$watch(
            () => {
                if (this.$refs.pagination) {
                    return this.$refs.pagination.pages
                }
            },
            value => {
                if (value) {
                    this.$set(this, 'refPaginationPagesLength', value[value.length - 1])

                    Object.assign(this.$refs.pagination, {getPages: this.getPages(this.$refs.pagination)})
                    Object.assign(this.$refs.pagination2, {getPages: this.getPages(this.$refs.pagination2)})
                }
            }
        )
    }
}
</script>

<style lang="scss">
.dsTable {
    overflow: hidden;

    &__content {
        overflow-x: auto;

        th {
            padding: 0;
        }
    }

    .contentCenter {
        th .head {
            justify-content: center;
        }

        td {
            text-align: center;
        }
    }

    table {
        border-collapse: collapse;
        //border-spacing: 0px 15px;
    }

    .td {
        background-color: white;

        &:first-child {
            border-top-left-radius: .5rem;
            border-bottom-left-radius: .5rem;
        }

        &:last-child {
            border-top-right-radius: .5rem;
            border-bottom-right-radius: .5rem;
        }
    }

    .spacertr_gr {
        &:nth-child(2n) {
            .spacertd {
                background-color: rgba(var(--vs-bodyBg), 1) !important;
            }
        }
    }

    .spacertr {
        &:nth-child(2n) {
            .spacertd {
                background-color: rgba(var(--vs-bodyBg), 1);
            }
        }
    }

    .activeExpand {
        transform: rotate(180deg);
        transition: .25s ease;
    }

    .chevron-down {
        transition: .25s ease;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .vs-pagination--ul {
        li {
            font-size: .8rem;
            width: 30px;
            height: 30px;
        }
    }

    .search input {
        border-radius: 50px;
    }

    .vs-inputx {
        &:focus {
            border: 1px solid rgba(0, 0, 0, 0.2) !important;
            box-shadow: none !important;
        }
    }

    &.loader {
        button, .head {
            pointer-events: none;
            opacity: .8;
        }

        ul {
            li {
                opacity: .8;
                pointer-events: none;
            }
        }
    }

    .disabled-pagination {
        pointer-events: none;
        color: gray;
    }

    &__arrow {
        .chevron-down {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 30px;
        }
    }

    &__checkbox {
        width: 20px;
        height: 20px;
        border-radius: 6px;
        border: 1px solid rgba(var(--vs-primary), 1);
        cursor: pointer;
        accent-color: rgba(var(--vs-primary), 1)
    }
}
</style>
